<script setup>
import { computed, ref, onMounted, watch, toRaw } from 'vue';
import { supabase } from '@/supabase';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

import { trimestres } from '@/store/dadosPadrao';
import { carregarCompetencias } from '@/api/fetchParecer';


import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Menu from 'primevue/menu'
import Textarea from 'primevue/textarea'
import ScrollPanel from 'primevue/scrollpanel'
import Dropdown from 'primevue/dropdown'
import MultiSelect from 'primevue/multiselect'
import ProgressBar from 'primevue/progressbar'
import Toast from 'primevue/toast'

import CriarGoogleForms from '@/components/professor/CriarGoogleForms.vue'

import { useToast } from "primevue/usetoast"

import BookEditOutlineIcon from 'vue-material-design-icons/BookEditOutline.vue'
import FolderSearchOutlineIcon from 'vue-material-design-icons/FolderSearchOutline.vue'
import CalendarMonthOutlineIcon from 'vue-material-design-icons/CalendarMonthOutline.vue'
import GoogleClassroomIcon from 'vue-material-design-icons/GoogleClassroom.vue'
import InlineMessage from 'primevue/inlinemessage';

const store = useStore()
const route = useRoute()
const router = useRouter()


// DADOS
const loading = ref(false)
const loadingHeader = computed(() => store.state.loading);
const competencias = ref([]);
const idDaDisciplina = ref(null);
const turma = computed(() => store.state.turma)
const anoDoEnsinoMedio = ref(null);
anoDoEnsinoMedio.value = store.state.turma.anoDoEnsinoMedio
idDaDisciplina.value = store.state.userSession.user.disciplina;


const mensagemObrigatoriedadeCompetencia = ref(`Para você conseguir inserir um plano de aula, precisa adicionar uma
                        competência. Para fazer isso, <a
                            href="https://minha-escola-olive.vercel.app/professor/elaborar-parecer" target="_blank" rel="noopener noreferrer">clique aqui</a>,
                        selecione o trimestre adequado e clique em "Definir competências dos componentes." Essas
                        competências são as do pacto e serão usadas para criar pareceres.`);


const anoAtual = ref()
// DADOS OPÇÕES
const criterios = ref([])
const aulas = ref([])
const aulaNaoDescelecionavel = ref()
const estudantes = ref()


const plano = ref({
    id: null,
    titulo: '',
    competencia: null,
    linkComOrientacoes: '',
    trimestre: '',
    estado: 'novo',
    estadoSubItens: 'novo',
    avaliacoes: [
        { tipo: 1, plano: null, criterio: 1, nivel1: "Minimamente desenvolvido", nivel2: "Parcialmente desenvolvido", nivel3: "Plenamente desenvolvido", nivel4: "Excede expectativas", estado: 'novo', titulo: '' },
        { tipo: 1, plano: null, criterio: 2, nivel1: "Minimamente desenvolvido", nivel2: "Parcialmente desenvolvido", nivel3: "Plenamente desenvolvido", nivel4: "Excede expectativas", estado: 'novo', titulo: '' },
        { tipo: 1, plano: null, criterio: 3, nivel1: "Minimamente desenvolvido", nivel2: "Parcialmente desenvolvido", nivel3: "Plenamente desenvolvido", nivel4: "Excede expectativas", estado: 'novo', titulo: '' },
        { tipo: 1, plano: null, criterio: 4, nivel1: "Minimamente desenvolvido", nivel2: "Parcialmente desenvolvido", nivel3: "Plenamente desenvolvido", nivel4: "Excede expectativas", estado: 'novo', titulo: '' },
        { tipo: 1, plano: null, criterio: 5, nivel1: "Minimamente desenvolvido", nivel2: "Parcialmente desenvolvido", nivel3: "Plenamente desenvolvido", nivel4: "Excede expectativas", estado: 'novo', titulo: '' },
        { tipo: 1, plano: null, criterio: 6, nivel1: "Minimamente desenvolvido", nivel2: "Parcialmente desenvolvido", nivel3: "Plenamente desenvolvido", nivel4: "Excede expectativas", estado: 'novo', titulo: '' },

    ],
    aulas: [],
    notas: [
        {
            id: null,
            avaliacao: null,
            nota: null,
            estudante: null,
            estado: 'novo'
        }
    ]
})

if (route.query.id != undefined) {
    plano.value.id = route.query.id
}

const menu = ref();
const toggle = (event) => {
    menu.value.toggle(event);
};

const items = ref([
    {
        items: [
            {
                label: 'Rubrica',
                command: adicionarAvaliacaoRubruca
            },
            {
                label: 'Percentual',
                command: adicionarAvaliacaoPercentual
            }

        ]
    }
]);



// GERENCIADORES DE ESTADO DO PLANO

function removerAvaliacao(index) {
    if (plano.value.avaliacoes[index].estado === 'novo') {
        plano.value.avaliacoes.splice(index, 1)
    } else {
        plano.value.avaliacoes[index].estado = 'removido'
        valoresAtualizados.value = true
        plano.value.estadoSubItens = 'modificado'
    }
}

function modificarAvaliacao(index) {
    if (plano.value.avaliacoes[index].estado !== 'novo') {
        plano.value.avaliacoes[index].estado = 'modificado'
        plano.value.estadoSubItens = 'modificado'
        valoresAtualizados.value = true
    }
}

function adicionarAvaliacaoRubruca() {
    plano.value.avaliacoes.push({ tipo: 1, plano: null, criterio: 1, nivel1: "Minimamente desenvolvido", nivel2: "Parcialmente desenvolvido", nivel3: "Plenamente desenvolvido", nivel4: "Excede expectativas", estado: 'novo', titulo: '' })
    if (plano.value.estado == 'novo') {
        return
    }
    plano.value.estadoSubItens = 'modificado'
    valoresAtualizados.value = true
}
function adicionarAvaliacaoPercentual() {
    plano.value.avaliacoes.push({ tipo: 2, plano: null, criterio: 1, nivel1: "", nivel2: "", nivel3: "", nivel4: "", estado: 'novo', titulo: '', formsId: '' })
    if (plano.value.estado == 'novo') {
        return
    }
    plano.value.estadoSubItens = 'modificado'
    valoresAtualizados.value = true
}



let estadoAnterior = JSON.parse(JSON.stringify(toRaw(plano.value)));

watch(plano, (novoValor) => {
    if (!dadosCarregados.value) return

    // ALTERA ESTADO DO PLANO
    if (novoValor.titulo !== estadoAnterior.titulo || novoValor.linkComOrientacoes !== estadoAnterior.linkComOrientacoes || novoValor.trimestre != estadoAnterior.trimestre || novoValor.competencia !== estadoAnterior.competencia) {
        if (plano.value.estado !== 'novo') {
            plano.value.estado = 'modificado'
            valoresAtualizados.value = true
        }

    }


    // Atualizar o estado anterior
    estadoAnterior = JSON.parse(JSON.stringify(toRaw(novoValor)));

    function updateAulasEmDensenvolvimento() {
        // ADICIONA NOVOS ALUNOS QUANDO UMA AULA É ADICIONADA
        if (novoValor.aulas.length > estadoAnterior.aulas.length) {

            let aulasAdicionadas = novoValor.aulas.filter(novaAula =>
                !estadoAnterior.aulas.some(antigaAula => antigaAula.idDaAula === novaAula.idDaAula));


            aulasAdicionadas.forEach((aulaAdicionada) => {
                plano.value.aulas.forEach((aula) => {
                    if (aula.idDaTurma !== aulaAdicionada.idDaTurma) {
                        estudantes.value.forEach((estudante) => {
                            if (estudante.turma == aulaAdicionada.idDaTurma) {
                                plano.value.avaliacoes.forEach((avaliacao) => {
                                    plano.value.notas.push({ id: null, avaliacao: avaliacao.id, nota: 0, estudante: estudante.estudante, estado: 'novo' })
                                })
                            }
                        })
                    }
                })
            })
        }

        // MARCA ALUNOS COMO EXCLUÍDO QUANDO UMA AULA É REMOVIDA (não funcionado)
        if (novoValor.aulas.length < estadoAnterior.aulas.length) {
            const aulasRemovidas = estadoAnterior.aulas.filter(antigaAula =>
                !novoValor.aulas.some(novaAula => novaAula.idDaAula === antigaAula.idDaAula));

            aulasRemovidas.forEach((aulaRemovida) => {
                plano.value.aulas.forEach((aula) => {
                    estudantes.value.forEach((estudante) => {
                        if (estudante.turma == aulaRemovida.idDaTurma) {
                            plano.value.notas = plano.value.notas.filter((nota) => {
                                if (nota.estudante == estudante.estudante) {
                                    if (nota.estado == 'novo') {
                                        // Exclui este item do array
                                        return false;
                                    } else {

                                        nota.estado = 'removido'
                                    }
                                }
                                return true;
                            });
                        }
                    });
                });
            });



        }
    }


}, { deep: true });

// GERANCIAR OPERAÇÕES CRUD
async function geranciarOperacoesCRUD() {
    if (plano.value.estado === 'novo' && plano.value.estadoSubItens === 'novo') {

        let idPlano = await salvarPlano({
            titulo: plano.value.titulo,
            linkComOrientacoes: plano.value.linkComOrientacoes,
            trimestre: plano.value.trimestre,
            competencia: plano.value.competencia
        })
        plano.value.id = idPlano
        plano.value.estado = 'salvo'
       

        let avaliacoes = []
        plano.value.avaliacoes.forEach(avaliacao => {
            avaliacoes.push({
                tipo: avaliacao.tipo,
                plano: idPlano,
                criterio: avaliacao.criterio,
                nivel1: avaliacao.nivel1,
                nivel2: avaliacao.nivel2,
                nivel3: avaliacao.nivel3,
                nivel4: avaliacao.nivel4,
                titulo: avaliacao.titulo
            })
        })


        let avaliacoesIds = await salvarAvaliacoes(avaliacoes)
        for (let i = 0; i < avaliacoesIds.length; i++) {
            plano.value.avaliacoes[i].plano = idPlano
            plano.value.avaliacoes[i].id = avaliacoesIds[i]
            plano.value.avaliacoes[i].estado = 'salvo'
        }

        let aulas = []
        plano.value.aulas.forEach(aula => {
            aulas.push({
                plano: idPlano,
                aula: aula.idDaAula
            })
        })

        let aulasIds = await salvarAulas(aulas)
        for (let i = 0; i < aulasIds.length; i++) {
            plano.value.aulas[i].id = aulasIds[i].id
            plano.value.aulas[i].estado = 'salvo'
        }



        let turmasSelecionadas = []
        plano.value.aulas.forEach(aula => {
            if (!turmasSelecionadas.includes(aula.idDaTurma)) {
                turmasSelecionadas.push(aula.idDaTurma)
            }
        })


        let notas = []
        turmasSelecionadas.forEach(turma => {
            estudantes.value.forEach(estudante => {
                if (estudante.turma === turma) {
                    plano.value.avaliacoes.forEach(avaliacao => {
                        notas.push({
                            avaliacao: avaliacao.id,
                            nota: 0,
                            estudante: estudante.estudante
                        })
                    })
                }
            })
        })

        let notasIds = await salvarNotas(notas, avaliacoesIds)
        for (let i = 0; i < notasIds.length; i++) {
            notas[i].id = notasIds[i]
            notas[i].estado = 'salvo'
        }

        plano.value.notas = notas

        plano.value.estadoSubItens = 'salvo'

        router.replace({ name: 'AdicionarPlano', query: { id: idPlano } });
        return

    }

    if (plano.value.estado == 'modificado') {
        atualizarPlano()
    }



    if (plano.value.estadoSubItens == 'modificado') {
        let avaliacoesParaSalvar = []
        let avaliacoesParaAtualizar = []
        let avaliacoesParaEscluir = []

        plano.value.avaliacoes.forEach(avaliacao => {
            if (avaliacao.estado == 'novo') {
                avaliacoesParaSalvar.push({
                    titulo: avaliacao.titulo,
                    tipo: avaliacao.tipo,
                    plano: plano.value.id,
                    criterio: avaliacao.criterio,
                    nivel1: avaliacao.nivel1,
                    nivel2: avaliacao.nivel2,
                    nivel3: avaliacao.nivel3,
                    nivel4: avaliacao.nivel4
                })
            } else if (avaliacao.estado == 'modificado') {
                avaliacoesParaAtualizar.push(avaliacao)
            } else if (avaliacao.estado == 'removido') {
                avaliacoesParaEscluir.push(avaliacao.id)
            }
        })


        for (const avaliacao in avaliacoesParaAtualizar) {
            atualizarAvaliacoes(avaliacoesParaAtualizar[avaliacao])
        }
        plano.value.avaliacoes.forEach(avaliacao => {
            if (avaliacao.estado == 'modificado') {
                avaliacao.estado = 'salvo'
            }
        })
        valoresAtualizados.value = false



        if (avaliacoesParaEscluir.length > 0) {
            excluirAvaliacoes(avaliacoesParaEscluir)
        }

        let turmasSelecionadas = []
        plano.value.aulas.forEach(aula => {
            if (!turmasSelecionadas.includes(aula.idDaTurma)) {
                turmasSelecionadas.push(aula.idDaTurma)
            }
        })

        let avaliacoesIds = await salvarAvaliacoes(avaliacoesParaSalvar)

        let notasSalvar = []

        for (let i = 0; i < avaliacoesIds.length; i++) {
            if (plano.value.avaliacoes[i].estado == 'novo') {
                plano.value.avaliacoes[i].plano = plano.value.id
                plano.value.avaliacoes[i].id = avaliacoesIds[i]
                plano.value.avaliacoes[i].estado = 'salvo'


                estudantes.value.forEach(estudante => {
                    if (turmasSelecionadas.includes(estudante.turma)) {
                        notasSalvar.push({
                            avaliacao: avaliacoesIds[i],
                            nota: 0,
                            estudante: estudante.estudante,
                        })

                        plano.value.notas.push({
                            id: null,
                            nota: 0,
                            avaliacao: avaliacoesIds[i],
                            estudante: estudante.estudante,
                            estado: 'novo'
                        })
                    }
                })
            }
        }

        let notasIds = await salvarNotas(notasSalvar, avaliacoesIds)

        for (let i = 0; i < notasIds.length; i++) {
            plano.value.notas.forEach(nota => {
                if (nota.estado == 'novo') {
                    nota.id = notasIds[i]
                    nota.estado = 'salvo'
                }
            })
        }


    }



}

// CARREGAR DADOS
async function carregarPlanoCompleto() {
    store.dispatch("updateLoading", true)
    const { data, error } = await supabase
        .from('planos')
        .select(`id, titulo, linkComOrientacoes, trimestre, competencia,
                            planos_avaliacoes(id,plano,tipo,criterio,nivel1,nivel2,nivel3,nivel4, titulo, forms_id, id_questao_com_nomes, planos_notas(id, estudante, nota)), 
                            planos_aulas(id, plano, aula, 
                            aulas(
                                turmas(id,nome),
                                cursos(disciplinas(nome))
                                ))`)
        .eq('id', plano.value.id)
        .single()

    if (error || data.length < 1) {
        alert('Ocorreu um erro, recarregue a página' + error.message)
        return
    }

    // DADOS DO PLANO
    plano.value.id = data.id
    plano.value.titulo = data.titulo
    plano.value.competencia = data.competencia
    plano.value.linkComOrientacoes = data.linkComOrientacoes
    plano.value.trimestre = data.trimestre
    plano.value.estado = 'salvo'
    plano.value.estadoSubItens = 'salvo'



    // DADOS DAS AULAS
    let aulasSelecionadas = []
    data.planos_aulas.forEach(item => {
        aulasSelecionadas.push({
            nome: item.aulas.turmas.nome + ' - ' + item.aulas.cursos.disciplinas.nome,
            idDaAula: item.aula,
            idDaTurma: item.aulas.turmas.id,
        })
    })

    plano.value.aulas = aulasSelecionadas


    // DADOS DAS AVALIACOES
    let avaliacoes = []
    let notas = []
    data.planos_avaliacoes.forEach(item => {
        avaliacoes.push({ id: item.id, tipo: item.tipo, criterio: item.criterio, nivel1: item.nivel1, nivel2: item.nivel2, nivel3: item.nivel3, nivel4: item.nivel4, estado: 'salvo', formsId: item.forms_id, questaoComNomes: item.id_questao_com_nomes, titulo: item.titulo })
        item.planos_notas.forEach(nota => {
            notas.push({ id: nota.id, avaliacao: item.id, nota: nota.nota, estudante: nota.estudante, estado: 'salvo' })
        })
    })


    avaliacoes.sort((a, b) => a.id - b.id)

    plano.value.avaliacoes = avaliacoes
    plano.value.notas = notas

    store.dispatch("updateLoading", false)
}
async function carregarOpcoes() {
    store.dispatch("updateLoading", true)
    const { data: criteriosLocal, error1 } = await supabase
        .from('criterios_rubrica')
        .select('*')
    if (error1) {
        store.dispatch("updateLoading", false)
        alert(error1.message)
        return
    }
    criterios.value = criteriosLocal

    const { data, error2 } = await supabase
        .from('aulas')
        .select('id, turmas!inner (id, nome, ano), cursos!inner (disciplinas(nome, id), anos_letivos(ano))')
        .eq('cursos.anos_letivos.ano', anoAtual.value)
        .eq('turmas.ano', turma.value.anoDoEnsinoMedio)
        .not('turmas', 'is', null)
        .not('cursos.anos_letivos', 'is', null)


    if (error2) {
        store.dispatch("updateLoading", false)
        alert(error2.message)
        return
    }

    let array = []
    data.forEach(item => {
        // if(item.id == turma.value.idDaAula){
        //     array.push({ id: item.id, nome: item.turmas.nome + " - " + item.cursos.disciplinas.nome, idDaTurma: item.turmas.id, idDaAula: item.id, disabled:true })
        // }else{
        //     array.push({ id: item.id, nome: item.turmas.nome + " - " + item.cursos.disciplinas.nome, idDaTurma: item.turmas.id, idDaAula: item.id, disabled:false })
        // }

        array.push({ nome: item.turmas.nome + " - " + item.cursos.disciplinas.nome, idDaTurma: item.turmas.id, idDaAula: item.id })

    })


    aulas.value = array
    plano.value.aulas = array.filter(item => item.idDaAula === turma.value.idDaAula);
    aulaNaoDescelecionavel.value = array.filter(item => item.idDaAula === turma.value.idDaAula);


    competencias.value = await carregarCompetencias([{ id: idDaDisciplina.value}], plano.value.trimestre, anoDoEnsinoMedio.value);

    store.dispatch("updateLoading", false)


}

//READ
async function carregarEstudantesTurmasSelecionadas() {
    store.dispatch("updateLoading", true)
    let turmasSelecionadas = aulas.value.map(item => item.idDaTurma)

    let { data: estudantes_turmas, error } = await supabase
        .from('estudantes_turmas')
        .select(`idDaTurma, users(id)`)
        .in('idDaTurma', turmasSelecionadas)

    if (error) {
        store.dispatch("updateLoading", false)
        alert(error.message)
        return
    }

    let array = []
    estudantes_turmas.forEach(item => {
        array.push({ id: null, avaliacao: null, estudante: item.users.id, turma: item.idDaTurma })
    })

    estudantes.value = array
    store.dispatch("updateLoading", false)

}


//CREATE
async function salvarPlano(plano) {
    let { data: idPlano, error } = await supabase
        .from('planos')
        .insert(plano)
        .select()
        .single()

    if (error) {
        alert(error.message)
        return
    }

    return idPlano.id
}

async function salvarAvaliacoes(avaliacoes) {
    const { error } = await supabase
        .from('planos_avaliacoes')
        .insert(avaliacoes)

    if (error) {
        alert(error.message)
        retun
    }

    const { data: avaliacoesIds } = await supabase
        .from('planos_avaliacoes')
        .select('id')
        .eq('plano', plano.value.id)
        .order('id', { ascending: true })

    let ids = avaliacoesIds.map(item => item.id)
    if (error) {
        alert(error.message)
        return
    }
    return ids
}

async function salvarAulas(aulas) {
    const { error } = await supabase
        .from('planos_aulas')
        .insert(aulas)

    const { data: aulasIds } = await supabase
        .from('planos_aulas')
        .select('id')
        .eq('plano', plano.value.id)

    return aulasIds
}

async function salvarNotas(notas, avaliacoesIds) {

    const { error } = await supabase
        .from('planos_notas')
        .insert(notas)

    const { data: notasIds } = await supabase
        .from('planos_notas')
        .select('id')
        .in('avaliacao', avaliacoesIds)

    let ids = notasIds.map(item => item.id)
    return ids
}

//UPDATE
async function atualizarPlano() {
    const { data, error } = await supabase
        .from('planos')
        .update({ titulo: plano.value.titulo, linkComOrientacoes: plano.value.linkComOrientacoes, trimestre: plano.value.trimestre, competencia: plano.value.competencia })
        .eq('id', plano.value.id)
        .select()

    if (error) {
        alert(error.message)
        return
    }

    valoresAtualizados.value = false
    plano.value.estado = 'salvo'

}
async function atualizarAvaliacoes(avaliacao) {
    const { data, error } = await supabase
        .from('planos_avaliacoes')
        .update({ criterio: avaliacao.criterio, nivel1: avaliacao.nivel1, nivel2: avaliacao.nivel2, nivel3: avaliacao.nivel3, nivel4: avaliacao.nivel4, titulo: avaliacao.titulo })
        .eq('id', avaliacao.id)

    if (error) {
        alert(error.message)
    }
}
async function atualizarAulas() {

}

//DELETE
async function excluirPlano() {

}

async function excluirAvaliacoes(avaliacoes) {
    for (const avaliacao of avaliacoes) {
        const { data, error } = await supabase
            .from('planos_avaliacoes')
            .delete()
            .eq('id', avaliacao)
    }

}

async function excluirNotas(notas) {
    for (const nota of notas) {
        const { data, error } = await supabase
            .from('planos_notas')
            .delete()
            .eq('id', nota)
    }

}

// FUNCÕES AUXILIARES
function verificarTrimestre() {
    const dataAtual = new Date();
    const mesAtual = dataAtual.getMonth();
    if (mesAtual <= 4) {
        plano.value.trimestre = "1"
    } else if (mesAtual <= 7) {
        plano.value.trimestre = "2"
    } else {
        plano.value.trimestre = "3"
    }
}
function obterAnoAtual() {
    let dataAtual = new Date()
    anoAtual.value = dataAtual.getFullYear()
}
const toast = useToast();

const showToastSuccess = (text) => {
    toast.add({ severity: 'success', detail: text, life: 3000 });
};

const showToastError = (text) => {
    toast.add({ severity: "error", detail: text, life: 3000 });
};
function goBack() {
    router.go(-1)
}
const valoresAtualizados = ref(false)
const dadosCarregados = ref(false)
const labelAtualizar = computed(() => {
    return valoresAtualizados.value ? 'Atualizar' : 'Atualizado';
});
onMounted(() => {
    obterAnoAtual()
    verificarTrimestre()
    carregarDados()
})

async function carregarDados() {
    await carregarOpcoes()
    await carregarEstudantesTurmasSelecionadas()
    if (plano.value.id !== null) {
        await carregarPlanoCompleto()
    }
    dadosCarregados.value = true
    estadoAnterior = JSON.parse(JSON.stringify(toRaw(plano.value)));
}

const handleFormIdUpdated = ({ idAvaliacao, formId }) => {
    plano.value.avaliacoes.find(avaliacao => avaliacao.id == idAvaliacao).formsId = formId
}

</script>

<template>
    <ProgressBar v-if="loadingHeader" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
    <Toast />
    <div class="header border-bottom-1 border-200 z-3">
        <div class="flex justify-content-between align-items-center w-full">
            <div class="text-color-secondary text-xl flex align-items-center">
                <Button @click="goBack" icon="pi pi-arrow-left" text rounded aria-label="Filter" severity="secondary" />
                <span class="ml-2">Voltar</span>

            </div>
            <div v-if="plano.id == null">
                <Button :disabled="plano.titulo == '' " :loading="loading" label="Criar"
                    size="small" type="submit" @click="geranciarOperacoesCRUD" text />
            </div>
            <div v-else>
                <Button :loading="loading" :label="labelAtualizar" size="small" type="submit"
                    :disabled="valoresAtualizados == false" @click="geranciarOperacoesCRUD" text />
            </div>

        </div>
    </div>



    <div class="surface-50 pt-8">
        <div class=" pt-4 pb-4 container" style="max-width: 1100px;">
            <div v-if="plano.competencia == null" class="hidden">
                <InlineMessage severity="info">
                    <div v-html="mensagemObrigatoriedadeCompetencia">
                       
                    </div>
                </InlineMessage>
            </div>
            <div>
                <div class="mb-3 mt-3 flex flex-column gap-2">
                    <div class="flex align-items-center">
                        <BookEditOutlineIcon class="text-color-secondary mr-3" />
                        <InputText type="text" v-model="plano.titulo" placeholder="Título do plano de aula"
                            class="w-full" required />
                    </div>
                    <div class="flex align-items-center">
                        <FolderSearchOutlineIcon class="text-color-secondary mr-3" />
                        <div class="flex flex-column gap-2 w-full">
                            <InputText id="link" type="text" v-model="plano.linkComOrientacoes" class="w-full"
                                placeholder="Link com material de pesquisa" />
                        </div>
                    </div>
                    <div class="flex align-items-center">
                        <CalendarMonthOutlineIcon class="text-color-secondary mr-3" />
                        <div class="flex flex-column gap-2 w-full">
                            <Dropdown v-model="plano.trimestre" :options="trimestres" optionLabel="trimestre"
                                optionValue="id" placeholder="Selecione o trimestre" class="w-full" />
                        </div>
                    </div>
                    <div class="flex align-items-center w-full">
                        <GoogleClassroomIcon class="text-color-secondary mr-3" />
                        <div class="flex flex-column gap-2 w-full">
                            <MultiSelect v-model="plano.aulas" :options="aulas" display="chip" filter optionLabel="nome"
                                placeholder="Postar em várias turmas/disciplinas" class="w-full" required
                                :disabled="plano.id != null" />
                        </div>
                    </div>
                    <div class="flex align-items-center">
                        <Dropdown v-model="plano.competencia" :options="competencias" optionLabel="competencia"
                            optionValue="id" placeholder="Selecione uma competência" class="w-full" />
                    </div>
                </div>

            </div>

            <div class="flex gap-3 mb-3">
                <Button icon="pi pi-chart-line" label="Adicionar Avaliação" text aria-haspopup="true"
                    aria-controls="overlay_menu" @click="toggle" />
                <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
                <!-- <Button v-if="idPlano != null" icon="pi pi-users" label="Adicionar Grupo" text /> -->
            </div>

            <div v-for="(avaliacao, index) in plano.avaliacoes" :key="index">
                <div v-if="avaliacao.estado != 'removido'">
                    <div v-if="avaliacao.tipo == 1">
                        <div class="bg-white border-round-md p-4 mb-1">
                            <div class="flex gap-2 justify-content-between">
                                <div class="block md:flex md:gap-2 md:align-items-center	">
                                    <Dropdown v-model="avaliacao.criterio" @change="modificarAvaliacao(index)"
                                        :options="criterios" optionLabel="criterio" optionValue="id"
                                        placeholder="Critério" class="w-full md:w-19rem mb-2 md:mb-0" />
                                    <InputText v-model="avaliacao.titulo" @keyup="modificarAvaliacao(index)"
                                        placeholder="Titulo" class="input-titulo-editar-plano w-full md:w-19rem" />
                                </div>
                                <Button icon="pi pi-times" severity="secondary" aria-label="Remover Avaliação"
                                    @click="removerAvaliacao(index)" text rounded />
                            </div>
                            <ScrollPanel style="width: 100%; height: 180px">


                                <div class="flex gap-2 mt-5 p-1 ">
                                    <span class="p-float-label">
                                        <Textarea v-model="avaliacao.nivel4" @keyup="modificarAvaliacao(index)" rows="6"
                                            cols="27" class="text-sm" />
                                        <label>Excede Expectativas</label>
                                    </span>
                                    <span class="p-float-label">
                                        <Textarea v-model="avaliacao.nivel3" @keyup="modificarAvaliacao(index)" rows="6"
                                            cols="27" class="text-sm" />
                                        <label>Plenamente Desenvolvido</label>
                                    </span>
                                    <span class="p-float-label">
                                        <Textarea v-model="avaliacao.nivel2" @keyup="modificarAvaliacao(index)" rows="6"
                                            cols="27" class="text-sm" />
                                        <label>Parcialmente Desenvolvido</label>
                                    </span>
                                    <span class="p-float-label">
                                        <Textarea v-model="avaliacao.nivel1" @keyup="modificarAvaliacao(index)" rows="6"
                                            cols="27" class="text-sm" />
                                        <label>Minimamente Desenvolvido</label>
                                    </span>
                                </div>

                            </ScrollPanel>
                        </div>

                    </div>
                    <div v-else>
                        <div class="bg-white border-round-md p-4 mb-1">
                            <div class="flex justify-content-between">
                                <InputText v-model="avaliacao.titulo" placeholder="Titulo"
                                    @keyup="modificarAvaliacao(index)" />
                                <Button icon="pi pi-times" severity="secondary" aria-label="Remover Avaliação"
                                    @click="removerAvaliacao(index)" text rounded />
                            </div>

                            <p v-if="avaliacao.formsId == ''">Isso já é suficiente para criar uma avaliação para inserir
                                percentual de acertos. Caso
                                deseje,
                                também pode criar um formulário para avaliar os estudantes</p>
                            <div v-if="avaliacao.formsId == ''">
                                <CriarGoogleForms :idAvaliacao="avaliacao.id" :turmas="plano.aulas"
                                    :titulo="avaliacao.titulo" @formIdUpdated="handleFormIdUpdated" />
                            </div>


                            <div class="mt-3" v-if="avaliacao.formsId != ''"><a
                                    :href="`https://docs.google.com/forms/d/${avaliacao.formsId}`"
                                    target="_blank">Visualizar Formulário</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style >
.p-dialog {
    max-height: 100%;
}

.p-dialog-content {
    height: 100%;
}

.p-dialog .p-dialog-header {
    border-radius: 0px;
}

.p-dialog-content {
    border-radius: 0px;
}

.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    box-sizing: border-box;
    background-color: #fff;
}
.input-titulo-editar-plano {
    height: 42.6667px;
}

</style>